import { useTheme, Stack } from '@mui/material';
import { useSubscription } from 'services/hooks';
import DurationSelector from './DurationSelector';
import DurationLimit from './DurationLimit';
import DurationUpgradeMessage from './DurationUpgradeMessage';
import { DurationSelectorProps } from './types';

const DurationSelectorContainer = ({
  value,
  onChange,
}: DurationSelectorProps) => {
  const theme = useTheme();

  const { isSubscriptionActive } = useSubscription();

  return (
    <Stack gap={theme.spacing(0.5)}>
      <DurationSelector
        value={value}
        onChange={onChange}
        disabled={!isSubscriptionActive}
      />
      {isSubscriptionActive && <DurationLimit />}
      {!isSubscriptionActive && <DurationUpgradeMessage />}
    </Stack>
  );
};

export default DurationSelectorContainer;
